<template>
    <div class="accordion flex flex-col gap-2.5 w-full" id="accordionExample">
        <div class="accordion-item shadow-[0px_0px_10px_-2px_#00000026] !rounded-[10px] overflow-hidden px-[10px] laptop:px-[20px] !border-0"
            :class="{ '': activeIndex === index }" v-for="(item, index) in accordionItems" :key="index">
            <h2 class="accordion-header" :id="'heading' + index">
                <!--:class="{ collapsed: activeIndex !== index, '!shadow-none !text-fuchsia-700': activeIndex === index }"  -->
                <button :class="[
                    'laptop:hover:!text-customBlue-100 accordion-button flex justify-between items-center text-sm laptop:text-base font-days !font-normal border-[#EFEFEF] !px-0 py-[10px] laptop:py-3 bg-transparent focus:!outline-none focus:!shadow-none !shadow-none after:hidden w-full text-left relative !text-black-100',
                    activeIndex === index ? 'border-b-[1px] border-[#EFEFEF] border-solid' : '!border-0'
                ]" type="button" :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="activeIndex = activeIndex === index ? null : index">
                    {{ item.title }}
                    <font-awesome-icon icon="angle-down" :class="[
                        ' transition-transform text-lg',
                        activeIndex === index ? 'rotate-180 text-customBlue-100' : 'text-customBlue-100'
                    ]" />
                </button>


            </h2>
            <transition name="accordion" @enter="enter" @leave="leave">
                <div v-if="activeIndex === index"
                    class="accordion-body !p-0 flex flex-col gap-[10px] laptop:gap-6"
                    v-html="item.content" :class="item.class">
                </div>
            </transition>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: null,
        };
    },
    computed: {
        accordionItems() {
            return this.items;
        },
    },
    watch: {
    },
    mounted() {  
        this.$nextTick(() => {
            this.activeIndex = 0;
        });
    },
    methods: {
        enter(el) {
            el.style.maxHeight = '0';
            el.style.paddingTop = '0';
            el.style.paddingBottom = '0';
            el.style.overflow = 'hidden';

            const fullHeight = el.scrollHeight;
            const computedStyle = getComputedStyle(el);
            const paddingTop = computedStyle.paddingTop;
            const paddingBottom = computedStyle.paddingBottom;

            requestAnimationFrame(() => {
                el.style.transition = 'max-height 0.5s ease, padding 0.5s ease';
                el.style.maxHeight = fullHeight + 'px';
                el.style.paddingTop = paddingTop;
                el.style.paddingBottom = paddingBottom;
            });

            el.addEventListener('transitionend', () => {
                el.style.maxHeight = 'none';
                el.style.transition = '';
                el.style.overflow = '';
            }, { once: true });
        },
        leave(el) {
            const computedStyle = getComputedStyle(el);
            const paddingTop = computedStyle.paddingTop;
            const paddingBottom = computedStyle.paddingBottom;

            el.style.maxHeight = el.scrollHeight + 'px';
            el.style.paddingTop = paddingTop;
            el.style.paddingBottom = paddingBottom;
            el.style.overflow = 'hidden';

            requestAnimationFrame(() => {
                el.style.transition = 'max-height 0.4s ease, padding 0.3s ease';
                el.style.maxHeight = '0';
                el.style.paddingTop = '0';
                el.style.paddingBottom = '0';
            });
        }
    },
};

</script>
<style>
.accordion-button {
    transition: border-color 0.2s ease;
}
</style>